import React from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { darkMode, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle" style={{ display:"none"}}>
      <input
        type="checkbox"
        id="theme-switch"
        className="theme-switch"
        checked={darkMode}
        onChange={toggleTheme}
      />
      <label htmlFor="theme-switch" className="theme-label">
        <FaSun className="theme-icon sun" />
        <FaMoon className="theme-icon moon" />
        <span className="theme-slider"></span>
      </label>
    </div>
  );
};

export default ThemeToggle;
